import React, { useEffect, useState } from 'react';
import IncludeDeliveries from '../../molecules/import/includeDeliveries';
import ConfigureFreight from '../../molecules/import/configureFreight';
import CheckImport from '../../molecules/import/checkImport';
import PublishFreight from '../../molecules/import/publishFreight';
import BoxWrapper from '../../atoms/boxWrapper';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import useGetVehicleTypes from '../../../hooks/vehicleType/useGetVehicleTypes';
import { FormProvider, useForm } from 'react-hook-form';
import colors from '../../../assets/styles/colors';
import { yupResolver } from '@hookform/resolvers/yup';
import schema from '../../molecules/import/configureFreight/schema';

const useStyles = makeStyles(() =>
  createStyles({
    stepperContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '15px',
    },

    stepper: {
      backgroundColor: colors.secondary.lightBlue,
      borderRadius: '50px',
      marginBottom: '20px',
    },

    lineActive: {
      height: '10px',
      borderRadius: '50px',
      width: '20%',
      backgroundColor: colors.warning.gold,
    },

    lineActive2: {
      height: '10px',
      borderRadius: '50px',
      width: '50%',
      backgroundColor: colors.warning.gold,
    },

    lineActive3: {
      height: '10px',
      borderRadius: '50px',
      width: '80%',
      backgroundColor: colors.warning.gold,
    },

    lineActive4: {
      height: '10px',
      borderRadius: '50px',
      width: '100%',
      backgroundColor: colors.success.green,
    },
  }),
);

const StepperImport: React.FC<{
  mode?: 'edit' | 'create';
  startStep?: number;
  initialValues?: any;
  disableVehicleTypeFromState?: boolean;
}> = ({ mode, startStep, initialValues, disableVehicleTypeFromState }) => {
  const classes = useStyles();
  const [step, setStep] = useState(startStep || 1);
  const [publishFreight, setPublishFreight] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const { execute, loading } = useGetVehicleTypes();
  const [isLoading, setIsLoading] = useState(false);
  const [disableVehicleType, setDisableVehicleType] = useState(
    !!disableVehicleTypeFromState,
  );

  const methods = useForm<any>({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      freightRequestId: '',
      isInternalFreight: false,
      freightId: '',
      totalDeliveries: 0,
      totalWeight: 0,
      deliveryRequests: [],
      waypoints: [],
      extraCarts: [],
      extraCartIds: [],
      numberOfHelpers: 0,
      pickUpDate: '',
      pickUpTime: '',
      deliveryLimitDate: '',
      freightType: '',
      freightStatus: '',
      ...(initialValues || {}),
    },
    context: { disableVehicleType },
  });

  const handleNextStep = () => {
    setStep(prevStep => prevStep + 1);
  };

  const handlePrevStep = (customStep?: number) => {
    setStep(prevStep => prevStep - (customStep ? customStep : 1));
  };

  const loadVehicleTypes = async () => {
    await execute(1, undefined, 100);
  };

  const handleFilesChange = (files: any) => {
    setUploadedFiles(files);
  };

  const showMissingFileHint = !methods.getValues('freightRequestId');

  useEffect(() => {
    loadVehicleTypes();
    //eslint-disable-next-line
  }, []);

  return (
    <FormProvider {...methods}>
      <BoxWrapper>
        <Box className={classes.stepperContainer}>
          <Box className={step === 1 ? 'active-step' : ''}>
            Incluir entregas
          </Box>
          <Box className={step === 2 ? 'active-step' : ''}>
            Configurar frete
          </Box>
          <Box className={step === 3 ? 'active-step' : ''}>
            Conferir importação
          </Box>
          <Box className={step === 4 ? 'active-step' : ''}>Publicar fretes</Box>
        </Box>

        <Box className={classes.stepper}>
          <Box
            className={step === 1 ? classes.lineActive : 'line-inactive'}
          ></Box>
          <Box
            className={step === 2 ? classes.lineActive2 : 'line-inactive'}
          ></Box>
          <Box
            className={step === 3 ? classes.lineActive3 : 'line-inactive'}
          ></Box>
          <Box
            className={step === 4 ? classes.lineActive4 : 'line-inactive'}
          ></Box>
        </Box>

        {step === 1 && (
          <IncludeDeliveries
            onNextStep={handleNextStep}
            onFilesChange={handleFilesChange}
          />
        )}
        {step === 2 && (
          <ConfigureFreight
            onNextStep={handleNextStep}
            onPrevStep={handlePrevStep}
            uploadedFiles={uploadedFiles}
            disableVehicleType={disableVehicleType}
            setDisableVehicleType={setDisableVehicleType}
            mode={mode}
          />
        )}
        {step === 3 && (
          <CheckImport
            onNextStep={handleNextStep}
            onPrevStep={handlePrevStep}
            publishFreight={publishFreight}
            setPublishFreight={setPublishFreight}
            setLoading={setIsLoading}
            mode={mode}
            freightId={initialValues?.freightId}
          />
        )}
        {step === 4 && (
          <PublishFreight
            publishFreight={publishFreight}
            setPublishFreight={setPublishFreight}
            isLoading={isLoading}
          />
        )}
      </BoxWrapper>
    </FormProvider>
  );
};

export default StepperImport;
